import type { ElementType, ReactNode } from 'react'
import RailHoverBubble from '@/shared/components/RailHoverBubble/RailHoverBubble'
import useRailHoverLabel from '@/shared/components/RailHoverBubble/useRailHoverLabel'
import ModulePictogram from './ModulePictogram/ModulePictogram'
import useModuleHeading from './useModuleHeading'
import { ModuleTitle, ModuleTitleGroup, RailButton } from './styled-components'

interface ModuleHeadingProps {
  icon: ElementType<{ size?: number; title?: string }>
  moduleKey: string
  label?: string
  statusDotLabel?: string
  highlighted?: boolean
  children: ReactNode
}

const ModuleHeading = ({ icon, moduleKey, label, statusDotLabel, highlighted, children }: ModuleHeadingProps) => {
  const { rail, count, railLabel, onOpen } = useModuleHeading({ moduleKey, label, children })
  const { anchorRef, geometry, show, hide } = useRailHoverLabel<HTMLButtonElement>()

  if (rail) {
    return (
      <>
        <RailButton
          ref={anchorRef}
          type='button'
          data-rail-module={moduleKey}
          aria-label={railLabel}
          onClick={onOpen}
          onMouseEnter={show}
          onMouseLeave={hide}
          onFocus={show}
          onBlur={hide}
        >
          <ModulePictogram icon={icon} count={count} moduleKey={moduleKey} statusDotLabel={statusDotLabel} />
        </RailButton>
        <RailHoverBubble geometry={geometry} label={children} side='left' />
      </>
    )
  }

  return (
    <ModuleTitleGroup>
      <ModulePictogram
        icon={icon}
        count={count}
        moduleKey={moduleKey}
        statusDotLabel={statusDotLabel}
        highlighted={highlighted}
      />
      <ModuleTitle $highlighted={highlighted}>{children}</ModuleTitle>
    </ModuleTitleGroup>
  )
}

export default ModuleHeading
